import { API_BASE } from '../variables/variablesConection';

// Envia un correo a traves de backendCotizaciones.
// Mantiene la firma anterior ({ Body, Correo, Asunto }) para no tocar las
// pantallas que ya la usan.
export async function sendCorreo(body) {
    try {
        const res = await fetch(`${API_BASE}/correo`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                to: body.Correo,
                subject: body.Asunto,
                html: body.Body,
            }),
        });
        return await res.text();
    } catch (error) {
        console.error('Error al enviar correo:', error);
        return '';
    }
}
